import { defaultTheme } from 'react-admin'
import { deepmerge } from '@mui/utils'

const baseColor = '#fefefe'
const complementaryLight = '#555'

const darkTheme = deepmerge(defaultTheme, {
  components: {
    RaFilterForm: {
      styleOverrides: {
        root: {
          minHeight: '0 !important',
        },
      },
    },
    RaHeader: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.toolbar.main,
          color: '#fefefe',
        }),
      },
    },
    RaDatagrid: {
      styleOverrides: {
        root: {
          '& .RaDatagrid-headerCell': {
            fontSize: '9pt',
            backgroundColor: complementaryLight,
            color: baseColor,
          },
          '& .RaDatagrid-rowCell': {
            fontSize: '8.5pt',
            '& .MuiTypography-root': {
              fontSize: '8.5pt', // for custom fields using Typography
            },
          },
          '& .MuiTableRow-root:has(.select-item input:checked)': {
            backgroundColor: '#2a4a4a',
            '&:hover': {
              backgroundColor: '#2a4a4a',
            },
          },
        },
      },
    },
    RaCreateButton: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: '#418c8f',
          color: baseColor,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.RaFormDialogTitle-closeButton': {
            color: '#fefefe'
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: baseColor,
          '&.Mui-selected': {
            backgroundColor: '#555',
            color: '#fff',
          },
        },
      },
    },
    MuiGrid2: {
      styleOverrides: {
        container: {
          width: '100%'
        },
      },
    },
  },
  typography: {
    ...defaultTheme.typography,
    fontFamily: 'Poppins, Arial, sans-serif',
    h6: { fontWeight: 600, color: baseColor },
    h5: { fontWeight: 600, color: baseColor },
    h4: { fontWeight: 700, color: baseColor },
    h3: { fontWeight: 700, color: baseColor },
    h2: { fontWeight: 800, color: baseColor },
    h1: { fontWeight: 800, color: baseColor },
  },
  palette: {
    ...defaultTheme.palette,
    mode: 'dark',
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: baseColor,
      secondary: '#B0B0B0',
    },
    primary: {
      light: '#7cc4c8',
      main: '#52acb0',
      dark: '#3a8a8e',
    },
    secondary: {
      main: '#5a7b6a',
      light: '#7a9c8a',
      dark: '#3e5a4c',
    },
    info: {
      main: baseColor,
    },
    ternary: {
      main: '#353535',
      light: '#555',
      dark: '#232323'
    },
    complementary: {
      main: '#cd9f87',
      light: complementaryLight,
      dark: '#fefefe',
    },
    tabs: {
      main: '#101010',
    },
    toolbar: {
      main: '#162e2f',
    },
    cards: {
      backgroundColor: {
        main: '#222',
      },
      title: {
        main: '#69b9bd',
      },
      contentBackgroundColor: {
        main: '#1e1e1e',
      },
    },
    gridList: {
      backgroundColor: '#141414',
      cards: {
        backgroundColor: '#1c2626',
        textColor: '#e8f3f2',
        textDate: '#8aaba8',
        icon: '#6ec4bb',
        chipBackgroundColor: '#4a9a8a',
      }
    },
    filterPanel: {
      backgroundColor: '#333',
      color: '#efefef',
    },
    favourited: {
      by: '#c84637'
    },
    state: {
      candidate:  '#4a9ec4',
      interested: '#6aaf7e',
      locked:     '#e06050',
      lastopened: '#3a8a8c',
    },
    status: {
      recontacter: { bg: '#4a3020', fg: '#f0c8a0', border: '#8a6040' },
      encours:     { bg: '#1a3040', fg: '#a0c8e0', border: '#4a7898' },
      inscrit:     { bg: '#1a3a38', fg: '#90cac8', border: '#4a8a88' },
      refuse:      { bg: '#3a3020', fg: '#c8b898', border: '#7a6a50' },
      rgpd:        { bg: '#3a1a14', fg: '#f0a090', border: '#984838' },
    },
    origin: {
      salon:      '#5ab0b3',
      site:       '#98c8c5',
      reco:       '#d4a080',
      instagram:  '#c080c3',
      facebook:   '#5a80cc',
      google:     '#e0b850',
      import:     '#88a898',
      partenaire: '#b06840',
      evenement:  '#4a98c0',
      formulaire: '#60a870',
      tel:        '#4a7a78',
      autre:      '#c8b898',
    },
  },
})

export default darkTheme
